import ApplicationAdapter from 'cio/adapters/application';
import { resolve } from 'rsvp';

// Some labels (like an event condition label) query the customers endpoint to
// find how many people match the condition. This overrides the queries.
export default class DemoCustomerAdapter extends ApplicationAdapter {
  query() {
    return resolve({
      customers: [],
      meta: {
        pagination: {
          total: 0,
          page: 1,
          size: 50,
        },
      },
    });
  }
}
